import React, { createContext, useState} from 'react'

const AppContext = createContext({
    token : '',
    agentToken: '',
    developerToken: '',
    systemAdminToken: '',
    isLoggedIn: false,
    login : (token) => {},
    logout: (type) => {}
});

export const AppProvider = ({ children }) => {
    const initialToken = localStorage.getItem('token');
    const initialAgentToken = localStorage.getItem('agenttoken');
    const initialDevToken = localStorage.getItem('developertoken');
    const initialSystemAdminToken = localStorage.getItem('systemAdminToken');

    const initialType = localStorage.getItem('type');
   
    const [ token, setToken ] = useState(initialToken);
    const [ agentToken, setAgentToken ] = useState(initialAgentToken);
    const [ developerToken, setDeveloperToken ] = useState(initialDevToken);

    const [ systemAdminToken, setSystemAdminToken ] = useState(initialSystemAdminToken);

    const [ loginType, setLoginType ] = useState(initialType);

    var userIsLoggedId = false;
    if(loginType === "E") {
        userIsLoggedId = !!agentToken;
    } else if(loginType === "A") {
        userIsLoggedId = !!token;
    } else if(loginType === "D"){
        userIsLoggedId = !!developerToken;
    }
    else if(loginType === "SA"){
        userIsLoggedId = !!systemAdminToken;
    }
    

    const loginHandler = (param) => {
        setLoginType(param.type)
        if(param.type === "E") {
            setAgentToken(param.token);
            localStorage.setItem('agenttoken', param.token);
            localStorage.setItem('agentInfo', param.loginData);
        } else if(param.type === "A") {
            setToken(param.token);
            localStorage.setItem('token', param.token);
            localStorage.setItem('adminInfo', param.loginData);
        } else if(param.type === "D") {
            setDeveloperToken(param.token)
            localStorage.setItem('developertoken', param.token);
            localStorage.setItem('developerinfo', param.loginData);
        }
        else if(param.type === "SA"){
            setSystemAdminToken(param.token);
            localStorage.setItem('systemAdminToken', param.token);
        }
        localStorage.setItem('type', param.type);
    }

    const logoutHandler = (param) => {
        if(param.type === "E") {
            setAgentToken(null);
            localStorage.removeItem('agenttoken')
            localStorage.removeItem('agentInfo')
            localStorage.removeItem('agent_id')
        } else if(param.type === "A") {
            setToken(null)
            localStorage.removeItem('token')
            localStorage.removeItem('adminInfo')
        } else if(param.type === "D"){
            setDeveloperToken(null)
            localStorage.removeItem('developertoken')
            localStorage.removeItem('developerinfo')
        }
        else if(param.type === "SA"){
            setSystemAdminToken(null);
            localStorage.removeItem('systemAdminToken')
        }
        localStorage.removeItem('type')
    }

    const contextValue = {
        token : token,
        agentToken: agentToken,
        developerToken: developerToken,
        systemAdminToken: systemAdminToken,
        isLoggedIn : userIsLoggedId,
        isLoginType : loginType,
        login : loginHandler,
        logout : logoutHandler
    }
    return (
        <AppContext.Provider value={ contextValue }>
            {children}
        </AppContext.Provider>
    )
}

export default AppContext;